import { ReactNode } from 'react';
import styles from './styles.scss';
import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon/index';

export const IconBase = ({
  children,
  className,
  appearance
}: IconProps & { children: ReactNode }) => (
  <span
    className={cn(styles.fontSized, className, {
      [styles.flip45]: appearance === 'flip-45',
      [styles.flip90]: appearance === 'flip-90',
      [styles.flip180]: appearance === 'flip-180',
      [styles.flip270]: appearance === 'flip-270'
    })}
  >
    {children}
  </span>
);
